export enum TypeIssuerEnum {
  AZURE = "AZURE",
  COGNITO = "COGNITO",
}
